import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["flash"];

  connect() {
    this.carOwnerId = this.element.dataset.carOwnerId;

    if (this.hasFlashTarget && this.flashTarget.dataset.flashNotice === "true"){
      this.createFlashMessage();
    }

    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const checkboxes = document.querySelectorAll("input[type='checkbox']:not([name='unsubscribe_from_all'])");

    checkboxes.forEach(checkbox => {
      checkbox.addEventListener("change", () => {
        let checkboxValue = checkbox.checked ? "1" : "0";

        fetch(`/car_owners/notifications/${this.carOwnerId}?${checkbox.name}=${checkboxValue}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': token
          }
        });

        this.createFlashMessage();
      });
    });
  }

  createFlashMessage() {
    const flashDiv = this.flashTarget;

    flashDiv.classList.remove('hidden');
    clearTimeout(flashDiv.timer);

    flashDiv.timer = setTimeout(() => {
      flashDiv.classList.add('hidden');
    }, 2000);
  }
}
